export function getWatchedPercentFromVideo({ currentTime, duration, ended }) {
  if (ended) {
    return 100;
  }
  if (!duration || !Number.isFinite(duration)) {
    return 0;
  }
  if (duration - currentTime < 0.5) {
    return 100;
  }
  return Math.floor((currentTime / duration) * 100);
}

export function getHighestReachedMilestone(watchedPercent, milestones) {
  const normalized = Number.isFinite(watchedPercent) ? Math.max(0, Math.min(100, watchedPercent)) : 0;
  let highest = null;
  for (const milestone of milestones) {
    if (normalized >= milestone) {
      highest = milestone;
    }
  }
  return highest;
}

export function getNextMilestonesToReport(maxSent, watchedPercent, milestones) {
  const highest = getHighestReachedMilestone(watchedPercent, milestones);
  if (highest === null || highest <= maxSent) {
    return [];
  }

  return milestones.filter((milestone) => milestone > maxSent && milestone <= highest);
}
